import queryString from 'query-string';

import { InterceptedAxios } from 'api/utils/axios-instances';
import { DEFAULT_PAGE_SIZE } from 'constants/table';
import { API_ROOT } from 'api/constants';
import { DEFAULT_BRAND_SEARCH } from 'constants/brands';
import { getCleanedObject } from 'utils';
import { getSearchOptionsFromQueryString } from 'hooks';

import {
  IBrands,
  IBrandsOptions,
  IDepartments,
  IDepartmentsOptions,
  IItem,
  IItems,
  ISearchOptions,
} from '../models';

export class CatalogService {
  // // GET variant
  // static search = ({
  //   q,
  //   page = 0,
  //   size = DEFAULT_PAGE_SIZE,
  //   ...options
  // }: ISearchOptions) => {
  //   const recombined = getCleanedObject({ q, page, size, ...options });
  //   // console.log('executing search: ', recombined);
  //   return InterceptedAxios.get<IItems>(
  //     `${API_ROOT}/search?${queryString.stringify(recombined, {
  //       arrayFormat: 'comma',
  //     })}`
  //   );
  // };

  // POST variant
  static search = ({
    page = 0,
    size = DEFAULT_PAGE_SIZE,
    sort,
    q,
    ...options
  }: ISearchOptions) => {
    const cleanedPaging = getCleanedObject({ page, size, sort });
    // kind of a weird way, but single items were coming through as strings instead of arrays, so we need to split them back into arrays
    const cleanedOptions = getCleanedObject({
      q,
      ...getSearchOptionsFromQueryString(
        new URLSearchParams(
          queryString.stringify(options, { arrayFormat: 'comma' })
        )
      ),
    });
    // console.log('cleanedPaging: ', cleanedPaging);
    // console.log('cleanedOptions: ', cleanedOptions);
    return InterceptedAxios.post<IItems>(
      `${API_ROOT}/search?${queryString.stringify(cleanedPaging, {
        arrayFormat: 'comma',
      })}`,
      cleanedOptions
    );
  };

  static getBrands = ({
    brandRegex = DEFAULT_BRAND_SEARCH,
    ...options
  }: IBrandsOptions) => {
    const recombined = {
      brandRegex: brandRegex || DEFAULT_BRAND_SEARCH,
      ...options,
    };
    // console.log('executing getBrands: ', recombined);
    return InterceptedAxios.get<IBrands>(
      `${API_ROOT}/brands?${queryString.stringify(recombined, {
        arrayFormat: 'comma',
      })}`
    );
  };

  static getDepartments = (options: IDepartmentsOptions) => {
    // console.log('executing getDepartments: ', options);
    return InterceptedAxios.get<IDepartments>(
      `${API_ROOT}/departments?${queryString.stringify(options, {
        arrayFormat: 'comma',
      })}`
    );
  };

  static getItemDetails = (itemNumber: string) => {
    // console.log('executing  getItemDetails: ', itemNumber);
    return InterceptedAxios.get<IItem>(`${API_ROOT}/items/${itemNumber}`);
  };
}
